import { useRef, useEffect } from "react";
import { X } from "lucide-react";
import { Dialog, DialogOverlay, DialogPortal } from "../ui/dialog";

interface VideoOverlayProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  videoUrl: string;
}

export function VideoOverlay({ open, onOpenChange, videoUrl }: VideoOverlayProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!open && videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay className="bg-black/60 backdrop-blur-xl backdrop-saturate-150" />
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-8"
          onClick={() => onOpenChange(false)}
        >
          <div
            className="relative w-full max-w-5xl animate-in fade-in-0 zoom-in-95 duration-300"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => onOpenChange(false)}
              className="absolute -top-14 right-0 rounded-full p-2 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white/70 hover:text-white transition-all focus:outline-none focus:ring-2 focus:ring-ring"
              aria-label="Close"
            >
              <X className="h-6 w-6" />
            </button>

            <div className="rounded-2xl overflow-hidden shadow-[0_0_80px_-20px_hsl(var(--primary)/0.4)] border border-white/15 bg-black">
              <video
                ref={videoRef}
                src={videoUrl}
                controls
                autoPlay
                className="w-full aspect-video"
                playsInline
              />
            </div>
          </div>
        </div>
      </DialogPortal>
    </Dialog>
  );
}
